import React, { useMemo } from 'react';
import { isPhoneNumber } from 'Utils/phoneUtil';
import { Styled } from './index.styles';
import { CallContactInfoProps } from './index.types';

const CallContactInfo: React.FC<CallContactInfoProps> = ({
  name,
  others,
  phoneNumber,
}) => {
  const otherNames = useMemo(() => {
    if (!others?.length) {
      return undefined;
    }

    if (others.length === 1) {
      return `or ${others[0].name}`;
    }

    return `or ${others.length} others`;
  }, [others]);

  return (
    <Styled.Container>
      <Styled.NameContainer>
        <Styled.Name>{name}</Styled.Name>
        {otherNames ? <Styled.Others>{otherNames}</Styled.Others> : <></>}
      </Styled.NameContainer>

      {phoneNumber && !isPhoneNumber(name) ? (
        <Styled.PhoneNumber>{phoneNumber}</Styled.PhoneNumber>
      ) : null}
    </Styled.Container>
  );
};

export default CallContactInfo;
